export default __webpack_public_path__ + "static/media/B2.7ae2798a.png";